import { render, staticRenderFns } from "./V2OrderSummary.vue?vue&type=template&id=32a79943&scoped=true&"
import script from "./V2OrderSummary.vue?vue&type=script&lang=js&"
export * from "./V2OrderSummary.vue?vue&type=script&lang=js&"
import style0 from "./V2OrderSummary.vue?vue&type=style&index=0&id=32a79943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a79943",
  null
  
)

export default component.exports